import { request } from "./request.js";

async function get(key) {
    return await request("/doctor", { key: key }, "POST");
}

async function save(data) {
    return await request("/doctor/save", data, "POST");
}

async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/doctor/list" + append, {}, "POST");
}

async function duty(doctorId, date, all = false) {
    const append = all === true ? '?all' : '';
    return await request("/doctor/duty" + append, { date: date, doctorId: doctorId }, "POST");
}

export { save, get, list, duty };
